import { EntityAdapter, createEntityAdapter, EntityState } from '@ngrx/entity';
import { AutomatedConfiguration } from '@era/settings-sdk';

export function selectBundleIdentifierFromAutomatedRollout(automatedConfiguration: AutomatedConfiguration) {
  return automatedConfiguration.id;
}

export const adapter: EntityAdapter<AutomatedConfiguration> = createEntityAdapter<AutomatedConfiguration>({
  selectId: selectBundleIdentifierFromAutomatedRollout,
});

export type AutomatedRolloutsState = EntityState<AutomatedConfiguration>;

export const initialState: AutomatedRolloutsState = adapter.getInitialState();
